import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Loader } from '@app/components';
import colors from '@app/constants/colors';

const Button = ({
  labelId,
  textColor,
  backgroundColor,
  longText,
  bordered,
  loading,
  wide,
  path,
  ...props
}) => (
  <StyledButton
    textColor={textColor}
    backgroundColor={backgroundColor}
    longText={longText}
    bordered={bordered}
    loading={loading}
    wide={wide}
    {...props}
    as={path ? Link : 'button'}
    to={path}
  >
    { loading ? <Loader dotsColor={backgroundColor} /> : <FormattedMessage id={labelId} /> }
  </StyledButton>
);

Button.propTypes = {
  labelId: PropTypes.string.isRequired, // translation id
  textColor: PropTypes.string.isRequired, // text color
  backgroundColor: PropTypes.string.isRequired, // background color
  longText: PropTypes.bool, // is small font size version
  bordered: PropTypes.bool, // is bordered version
  loading: PropTypes.bool, // is loader visible
  wide: PropTypes.bool, // is wide version
  path: PropTypes.string, // react inside route
};

Button.defaultProps = {
  longText: false,
  bordered: false,
  loading: false,
  wide: false,
  path: '',
};

const StyledButton = styled.button`
  border-radius: 33px;
  box-shadow: 0 3px 0 0 rgba(0,0,0,.15), inset 0 0 1px 0 rgba(0,0,0,.15);
  font-size: ${({ longText }) => (longText ? '16px' : '28px')};
  word-break: break-word; 
  padding: ${({ wide, longText }) => {
    if (longText) return '10px';
    if (wide) return '12px 55px';
    return '9px 30px';
  }};
  font-weight: ${({ wide }) => (wide ? 700 : 100)};
  border: ${({ bordered }) => (bordered ? '3px solid #f8f8f8' : 'none')};
  text-transform: uppercase;
  color: ${({ loading, textColor, backgroundColor }) => (loading ? backgroundColor : textColor)};
  background-color: ${({ loading, textColor, backgroundColor }) => (loading ? textColor : backgroundColor)};
  transition: all 0.5s ease;
  transform: translateY(0);
  display: inline-block;
  
  &:hover,
  &:focus {
    color: ${props => props.backgroundColor};
    background-color: ${props => props.textColor};  
    transition: all 0.5s ease;
  }
  
  &:focus {
    box-shadow: none;
    transform: translateY(3px);
  }
    
  &:disabled {
    color: ${({ loading, backgroundColor }) => (loading ? backgroundColor : colors.ALICE_BLUE)};
    background-color: ${({ loading, textColor }) => (loading ? textColor : colors.BUTTON_DISABLED)};
    cursor: default;
    transition: all 0.5s ease;
  }
  
  @media (max-width: 979px) {
    padding: 6px 30px;
    font-size: ${({ longText }) => (longText ? '16px' : '22px')};
  }  
`;

export default Button;
